export default "__VITE_ASSET__CYVlb7gF__"